<template>
  <section class="container page products">
    <h1>{{ $t('home.device_title') }}</h1>

    <div class="product-layout">
      <!-- 左侧 Tab 菜单 -->
      <div class="tabs-vertical">
        <button
      v-for="(tab, i) in tabs"
      :key="i"
      class="tab-btn"
      :class="{ active: activeTab === tab.key }"
      @click="activeTab = tab.key"
    >
      {{ $t(`home.device_tabs.${tab.key}`) }}
    </button>
      </div>

      <!-- 右侧产品展示区 -->
      <div class="product-content">
        <div class="product-list">
          <div
            v-for="(item, index) in currentList"
            :key="index"
            class="product-card"
            @click="goTo(item.url)"
          >
            <img :src="item.img" :alt="item.title" />
            <h3>{{ item.title }}</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProductList",
  data() {
    return {
      activeTab: "finished",
      tabs: [
        { key: "finished" },
        { key: "chip" }
      ],
      productsFinished: [
        {
          title: "Zigbee单火通断器控制器远程语音遥控开关电路通断器厂家批发",
          img: require("@/assets/images/devices/product1.jpg"),
          url: "https://detail.1688.com/offer/984742138571.html"
        },
        {
          title: "Zigbee3.0门窗传感器传感器支持tHomeAssistant,Z2M,ZHA",
          img: require("@/assets/images/devices/product2.jpg"),
          url: "https://detail.1688.com/offer/979671029903.html"
        },
        {
          title: "Zigbee Dongle,Zigbee3.0 支持 ZHA,Z2M,HomeAssistant嵌入式",
          img: require("@/assets/images/devices/product3.jpg"),
          url: "https://detail.1688.com/offer/975775225567.html"
        },
        {
          title: "Zigbee红外万能遥控,支持多种空调产品接入,技术对接远程控制",
          img: require("@/assets/images/devices/product4.jpg"),
          url: "https://detail.1688.com/offer/976420688434.html"
        },
        {
          title: "Zigbee3.0有线网关，MQTT，开放API，开源项目,兼容海量设备",
          img: require("@/assets/images/devices/product5.jpg"),
          url: "https://detail.1688.com/offer/975783917048.html"
        },
        {
          title: "Tuya WiF 蓝牙双模i温湿度WiIFI门磁高精度温湿度传感器智能",
          img: require("@/assets/images/devices/product6.jpg"),
          url: "https://detail.1688.com/offer/975065518926.html"
        },
        {
          title: "Zigbee3.0 国标计量插座 智能插座远程控制10A/16A计量墙壁插座",
          img: require("@/assets/images/devices/product7.jpg"),
          url: "https://detail.1688.com/offer/980850247480.html"
        },
        {
          title: "Zigbee3.0通断器zigbee开关通断器16A通断器,多路,支持Z2M,ZHA",
          img: require("@/assets/images/devices/product8.jpg"),
          url: "https://detail.1688.com/offer/978469271362.html"
        },
        {
          title: "Zigbee3.0温湿度传感器,高精度,高灵敏度无线温湿度HomeAssistant",
          img: require("@/assets/images/devices/product9.jpg"),
          url: "https://detail.1688.com/offer/976420960658.html"
        },
        {
          title: "zigbee水浸传感器 远程智能家居漏水溢水报警器便捷感应探测器",
          img: require("@/assets/images/devices/product10.jpg"),
          url: "https://detail.1688.com/offer/980861955153.html"
        },
        {
          title: "Zigbee3.0 墙插计量开关 智能插座白色外壳中规开关外壳厂家供应",
          img: require("@/assets/images/devices/product11.jpg"),
          url: "https://detail.1688.com/offer/982787020602.html"
        },
        {
          title: "zigbee零火开关 按键智能开关智能家居远程控制零火通用墙壁开关",
          img: require("@/assets/images/devices/product12.jpg"),
          url: "https://detail.1688.com/offer/980854031429.html"
        },
        {
          title: "Zigbee3.0驱动电源,12W,z2m,ZHA,HomeAssistant调光智能调光器",
          img: require("@/assets/images/devices/product13.jpg"),
          url: "https://detail.1688.com/offer/975074354229.html"
        },
        {
          title: "Zigbee3.0单火开关墙壁单火磁保持无外接电容,Z2M无零火适用",
          img: require("@/assets/images/devices/product14.jpg"),
          url: "https://detail.1688.com/offer/974553015276.html"
        },
        {
          title: "Zigbee3.0通断器zigbee开关通断器16A通断器,多路,支持Z2M,ZHA",
          img: require("@/assets/images/devices/product15.jpg"),
          url: "https://detail.1688.com/offer/976420688436.html"
        },
        {
          title: "Zigbee,3.0欧法规16A,20A计量插Tasmota Wifi,座支持ZHA,Z2M插头",
          img: require("@/assets/images/devices/product16.jpg"),
          url: "https://detail.1688.com/offer/974554175320.html"
        },
        {
          title: "Zigbee3.0门窗传感器传感器支持tHomeAssistant,Z2M,ZHA",
          img: require("@/assets/images/devices/product17.jpg"),
          url: "https://detail.1688.com/offer/974550263596.html"
        }
      ],
      productsChip: [
        {
          title: "Zigbee芯片模组，门磁，温湿度，水浸 3合1",
          img: require("@/assets/images/devices/chip1.jpg"),
          url: ""
        },
        // {
        //   title: "EFR32MG21 Zigbee芯片方案，低功耗高性能SoC模块",
        //   img: require("@/assets/images/devices/product17.jpg"),
        //   url: "https://detail.1688.com/offer/979431748282.html"
        // },
        // {
        //   title: "NXP JN5189 Zigbee模块，支持ZHA/Z2M/Thread协议栈",
        //   img: require("@/assets/images/devices/product17.jpg"),
        //   url: "https://detail.1688.com/offer/980789492120.html"
        // }
      ]
    };
  },
  computed: {
    currentList() {
      return this.activeTab === "chip" ? this.productsChip : this.productsFinished;
    }
  },
  methods: {
    goTo(url) {
      if (url) window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.products {
  max-width: 1200px;
  padding: 20px;
}

.products h1 {
  font-size: 28px;
  margin-bottom: 20px;
  text-align: left;
}

/* ====== 左右布局 ====== */
.product-layout {
  display: flex;
  align-items: flex-start;
  gap: 30px;
}

/* 左侧竖向 tabs */
.tabs-vertical {
  display: flex;
  flex-direction: column;
  width: 180px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px solid #eee;
  padding: 10px;
}

.tab-btn {
  padding: 10px 15px;
  border: none;
  background: transparent;
  border-radius: 8px;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-btn:hover {
  background: #f0f7ff;
}

.tab-btn.active {
  background: #409eff;
  color: #fff;
  font-weight: bold;
}

/* 右侧产品区域 */
.product-content {
  flex: 1;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}

.product-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-align: center;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.product-card img {
  width: 100%;
  object-fit: contain;
}

.product-card h3 {
  font-size: 16px;
  margin: 12px 0;
  padding: 0 8px;
  color: #333;
}
</style>
